import React, { Component } from 'react';
import { Button, OverlayTrigger, Table as TableB, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { bindActionCreators } from 'redux';

import { generics } from 'actions';
import { USER_SETUP } from 'actions/const';

class Table extends Component {
	render() {
		let { isLoading, stateSetter, getUsers, loadOptions, accessible } = this.props;

		let { setValue } = this.props.actions;

		let { tableData, filterUsername, filterName, filterMerchant } = this.props.usersetup;

		var tr = '';

		const TTview = <Tooltip id="tooltip">View</Tooltip>;
		const TTaddVIP = <Tooltip id="tooltip">Add VIP Member</Tooltip>;
		const TTmerchant = <Tooltip id="tooltip">Assign Merchant</Tooltip>;
		const TTupdate = <Tooltip id="tooltip">Update</Tooltip>;
		const TTdelete = <Tooltip id="tooltip">Delete</Tooltip>;

		if (isLoading) {
			tr = (
				<tr>
					<td
						colSpan={15}
						style={{
							textAlign: 'center',
							color: '#808080',
						}}
					>
						<i className="fa fa-spinner fa-spin fa-3x"></i>
					</td>
				</tr>
			);
		} else if (tableData.length === 0) {
			tr = (
				<tr>
					<td
						colSpan={15}
						style={{
							textAlign: 'center',
							color: '#808080',
						}}
					>
						No Data Available
					</td>
				</tr>
			);
		} else {
			const isUndefined = (obj) => (typeof obj === 'undefined' ? true : false);

			tr = tableData.map((data, index) => (
				<tr key={index}>
					<td>{!isUndefined(data.get('username')) ? data.get('username') : ''}</td>
					<td>{!isUndefined(data.get('name')) ? data.get('name') : ''}</td>
					<td style={{ textAlign: 'center' }}>
						{!isUndefined(data.get('userType')) ? (
							data.get('userType').toUpperCase() === 'ADMIN' ? (
								<i className="fa fa-check fa-lg"></i>
							) : (
								''
							)
						) : (
							''
						)}
					</td>
					<td style={{ textAlign: 'center' }}>
						{!isUndefined(data.get('userType')) ? (
							data.get('userType').toUpperCase() === 'VIP HOST' ? (
								<i className="fa fa-check fa-lg"></i>
							) : (
								''
							)
						) : (
							''
						)}
					</td>
					<td style={{ textAlign: 'center' }}>
						{!isUndefined(data.get('userType')) ? (
							data.get('userType').toUpperCase() === 'MERCHANT' ? (
								<i className="fa fa-check fa-lg"></i>
							) : (
								''
							)
						) : (
							''
						)}
					</td>
					<td style={{ textAlign: 'center' }}>
						{!isUndefined(data.get('userType')) ? (
							data.get('userType').toUpperCase() === 'PARTNER' ? (
								<i className="fa fa-check fa-lg"></i>
							) : (
								''
							)
						) : (
							''
						)}
					</td>
					<td>
						<OverlayTrigger placement="top" overlay={TTview}>
							<a
								className="fa fa-eye fa-lg"
								href="javascript:void(0)"
								onClick={() =>
									stateSetter([
										{ state: 'showModal', value: true },
										{ state: 'formType', value: 'VIEW' },
										{ state: 'selectedData', value: data },
									])
								}
								style={{ display: accessible('VIEW') }}
							/>
						</OverlayTrigger>
						<OverlayTrigger placement="top" overlay={TTupdate}>
							<a
								className="fa fa-pencil fa-lg"
								href="javascript:void(0)"
								onClick={() =>
									stateSetter([
										{ state: 'showModal', value: true },
										{ state: 'formType', value: 'UPDATE' },
										{ state: 'selectedData', value: data },
									])
								}
								style={{ display: accessible('UPDATE') }}
							/>
						</OverlayTrigger>
						<OverlayTrigger placement="top" overlay={TTdelete}>
							<a
								className="fa fa-trash fa-lg"
								href="javascript:void(0)"
								onClick={() =>
									stateSetter([
										{ state: 'showModal', value: true },
										{ state: 'formType', value: 'DELETE' },
										{ state: 'selectedData', value: data },
									])
								}
								style={{ display: accessible('DELETE') }}
							/>
						</OverlayTrigger>
					</td>
				</tr>
			));
		}

		return (
			<TableB hover responsive>
				<thead>
					<tr>
						<th>USERNAME</th>
						<th>NAME</th>
						<th>ADMIN</th>
						<th style={{ whiteSpace: 'nowrap' }}>VIP HOST</th>
						<th>MERCHANT</th>
						<th>PARTNER</th>
						<th></th>
					</tr>
					<tr>
						<td>
							<Select.Async
								autoload={false}
								value={filterUsername}
								loadOptions={(input, cb) =>
									loadOptions(input, cb, 'User', 'username')
								}
								onChange={(val) => setValue(USER_SETUP, 'filterUsername', val)}
							/>
						</td>
						<td>
							<Select.Async
								autoload={false}
								value={filterName}
								loadOptions={(input, cb) => loadOptions(input, cb, 'User', 'name')}
								onChange={(val) => setValue(USER_SETUP, 'filterName', val)}
							/>
						</td>
						<td></td>
						<td></td>
						<td style={{ minWidth: '180px' }}>
							<Select.Async
								autoload={false}
								value={filterMerchant}
								loadOptions={(input, cb) =>
									loadOptions(input, cb, 'Merchant', 'name')
								}
								onChange={(val) => setValue(USER_SETUP, 'filterMerchant', val)}
							/>
						</td>
						<td></td>
						<td>
							<Button
								className="btn-primary"
								onClick={() => getUsers()}
								style={{ display: accessible('FILTER') }}
							>
								SEARCH
							</Button>
						</td>
					</tr>
				</thead>
				<tbody>{tr}</tbody>
			</TableB>
		);
	}
}

function mapStateToProps(state) {
	var { usersetup } = state;
	const props = {
		usersetup,
	};
	return props;
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: generics.setValue,
	};
	const actionMap = {
		actions: bindActionCreators(actions, dispatch),
	};
	return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(Table);



// WEBPACK FOOTER //
// ./components/UserSetup/Table.js